import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useSKspListQuery } from '../../store/DianShangYeWuApi';
import LoanNodeCheckApprove from './IncomeNodeCheckApprove';
import LoanNodeCheckEdit from './IncomeNodeCheckEdit';
function IncomeNodeCheck(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useSKspListQuery({ddsr_sp_ddsr_id:props.ddsr_id},{skip:!props.ddsr_id})
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            // 然后 map，判断是否是最后一个元素
            const newArr =  data.Result.map(item => {
                const {
                    ddsr_sp_jd_name,
                    ddsr_sp_yh_name,
                    ddsr_sp_yh_id,
                    ddsr_sp_jd_xuhao,
                    ddsr_sp_content,
                    ddsr_sp_id,
                    ddsr_sp_dsbzd_id,
                    ddsr_sp_dsbzd_name,
                    ddsr_sp_state,
                    ddsr_sp_state_time,
                    ddsr_sp_uname,
                    ddsr_sp_ctime,
                    ddsr_sp_dsbzd_date,
                    ddsr_sp_dsbzd_date_end,
                    ddsr_sp_dsbzd_kh_id,
                    ddsr_sp_dsbzd_kh_name,
                } = item;
                return {
                    ddsr_sp_jd_name,
                    ddsr_sp_yh_name,
                    ddsr_sp_yh_id,
                    ddsr_sp_jd_xuhao,
                    ddsr_sp_content,
                    ddsr_sp_id,
                    ddsr_sp_dsbzd_id,
                    ddsr_sp_dsbzd_name,
                    ddsr_sp_state,
                    ddsr_sp_state_time,
                    ddsr_sp_uname,
                    ddsr_sp_ctime,
                    ddsr_sp_dsbzd_date,
                    ddsr_sp_dsbzd_date_end,
                    ddsr_sp_dsbzd_kh_id,
                    ddsr_sp_dsbzd_kh_name,
                }                
            })
            // 排序数据
            const sortedData = newArr.sort((a, b) => {
                return a.ddsr_sp_jd_xuhao - b.ddsr_sp_jd_xuhao;
            });
            // 生成 arr 并计算 current
            let firstApproveWithState2Index = -1; // 在 arr 中的索引（状态为 '2' 的审批点）
            let lastItemIndex = -1; // 在 arr 中的最后一个 item 的索引
            let arrIndex = 0; // arr 的当前索引
            
            const arr = sortedData.map((item) => {
                let result = null;
                if(item.ddsr_sp_jd_name === '审批' && item.ddsr_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:<span style={{fontSize:"12px"}}>{item.ddsr_sp_yh_name}</span>,
                        ddsr_sp_state:item.ddsr_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddsr_sp_jd_name === '审批' && item.ddsr_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.ddsr_sp_yh_id ? <LoanNodeCheckApprove 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        ddsr_id={props.ddsr_id}
                                                                        ddsr_date={props.ddsr_date}
                                                                        ddsr_kh_id={props.ddsr_kh_id}
                                                                        ddsr_kh_name={props.ddsr_kh_name}
                                                                        ddsr_sp_id={item.ddsr_sp_id}
                                                                        ddsr_sp_jd_xuhao={item.ddsr_sp_jd_xuhao}
                                                                        ddsr_sp_jd_name={item.ddsr_sp_jd_name}
                                                                        ddsr_sp_yh_id={item.ddsr_sp_yh_id}
                                                                        ddsr_sp_yh_name={item.ddsr_sp_yh_name}
                                                                        ddsr_sp_uid={item.ddsr_sp_uid}
                                                                        ddsr_sp_uname={item.ddsr_sp_uname}
                                                                    /> : <span style={{fontSize:"12px"}}>{item.ddsr_sp_yh_name}</span>,
                        ddsr_sp_state:item.ddsr_sp_state,
                                                                    
                    }
                    // 找到第一个状态为 '2' 的审批点
                    if(firstApproveWithState2Index === -1){
                        firstApproveWithState2Index = arrIndex;
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddsr_sp_jd_name === '审批' && (item.ddsr_sp_state==='3' || item.ddsr_sp_state==='4' || item.ddsr_sp_state==='5')){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.ddsr_sp_yh_id ? <LoanNodeCheckEdit 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        ddsr_id={props.ddsr_id}
                                                                        ddsr_date={props.ddsr_date}
                                                                        ddsr_kh_id={props.ddsr_kh_id}
                                                                        ddsr_kh_name={props.ddsr_kh_name}
                                                                        ddsr_sp_id={item.ddsr_sp_id}
                                                                        ddsr_sp_jd_xuhao={item.ddsr_sp_jd_xuhao}
                                                                        ddsr_sp_jd_name={item.ddsr_sp_jd_name}
                                                                        ddsr_sp_yh_id={item.ddsr_sp_yh_id}
                                                                        ddsr_sp_yh_name={item.ddsr_sp_yh_name}
                                                                        ddsr_sp_uid={item.ddsr_sp_uid}
                                                                        ddsr_sp_uname={item.ddsr_sp_uname}
                                                                        ddsr_sp_state={item.ddsr_sp_state}
                                                                        ddsr_sp_state_time={item.ddsr_sp_state_time}
                                                                        ddsr_sp_content={item.ddsr_sp_content}
                                                                    />: <Space orientation='vertical' size={0}>
                                                                            <span style={{color:item.ddsr_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                                                                                {item.ddsr_sp_state==='4' ? '驳回' : '同意'}
                                                                                {item.ddsr_sp_content? '：'+item.ddsr_sp_content :''}
                                                                            </span>
                                                                            <span>{item.ddsr_sp_yh_name} {item.ddsr_sp_state_time} </span>
                                                                        </Space>,
                                                                        ddsr_sp_state:item.ddsr_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddsr_sp_jd_name === '抄送' && item.ddsr_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.ddsr_sp_yh_name}</span>,
                        ddsr_sp_state:item.ddsr_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddsr_sp_jd_name === '抄送' && item.ddsr_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.ddsr_sp_yh_name}</span>,
                        ddsr_sp_state:item.ddsr_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.ddsr_sp_jd_name === '抄送' && item.ddsr_sp_state==='3'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.ddsr_sp_yh_name} {item.ddsr_sp_state_time}</span>,
                        ddsr_sp_state:item.ddsr_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                return result;
            })
            
            // 计算 current，规则优先级：'2' > '4' > 最后一个
            let calculatedCurrent = 0;
            let firstApproveWithState4Index = -1;

            // 查找 '2' 和 '4' 的索引
            arr.forEach((item, idx) => {
                if (item && item.ddsr_sp_state === '2' && firstApproveWithState2Index === -1) {
                    firstApproveWithState2Index = idx;
                }
                if (item && item.ddsr_sp_state === '4' && firstApproveWithState4Index === -1) {
                    firstApproveWithState4Index = idx;
                }
            });

            if (firstApproveWithState2Index !== -1) {
                calculatedCurrent = firstApproveWithState2Index;
            } else if (firstApproveWithState4Index !== -1) {
                calculatedCurrent = firstApproveWithState4Index;
            } else if (lastItemIndex !== -1) {
                calculatedCurrent = lastItemIndex;
            }

            // current 需要加上前面的"创建"和"提交"两个步骤
            setCurrent(calculatedCurrent + 2);
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"14px"}}>{props.ddsr_uname} {props.ddsr_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"14px"}}>{props.ddsr_uname} {props.ddsr_state_time}</span>,
            },...arr]);
        }else{
            setItems([]);
        }
        
        
    },[data, isSuccess,props.ddsr_id,props.ddsr_uname,props.ddsr_ctime,props.ddsr_state_time,props.ddsr_date,props.ddsr_kh_id,props.ddsr_kh_name,props.yh_id,props.yh_name])
    return (
        <Steps 
            items={items} 
            current={current} 
            size="small" 
            titlePlacement="vertical" 
        />
    )
}

export default IncomeNodeCheck